import React from 'react';
import Scrollbars, { ScrollbarProps } from 'react-custom-scrollbars';
import { useTheme } from 'styled-components';

const Scrollbar = (props: React.PropsWithChildren<ScrollbarProps>) => {
    const theme = useTheme();
    const renderThumb = React.useCallback(({ style, _props }: any): any => {
        return <div {..._props} style={{ ...style, backgroundColor: theme.newBg1, borderRadius: 10 }} />;
    }, []);

    const renderView = React.useCallback(({ style, _props }: any): any => {
        return <div {..._props} style={{ ...style, marginRight: -16, marginBottom: -16 }} />;
    }, []);

    return (
        <Scrollbars style={{}} {...props} renderThumbHorizontal={renderThumb} renderThumbVertical={renderThumb} renderView={renderView}>
            {props.children}
        </Scrollbars>
    )
}
export default Scrollbar;